export const GET_COURSE_HISTORY = "GET_COURSE_HISTORY"
export const SET_MODIFIED_COURSE_LIST = "SET_MODIFIED_COURSE_LIST"